(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    if ($('.component.form').length) window.DGS.Event.getInstance().trigger(window.DGS.Events.SELECT_ADDED, $('.component.form select'));
  });
})(jQuery);